<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }" v-if="">首页</el-breadcrumb-item>
                <el-breadcrumb-item>退款信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="simple-form">
            <div class="form-group center" v-if="tradeId != null && tradeId != -1">
                <div class="form-label">
                    <label>交易单号</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.no}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="tradeId != null && tradeId != -1 && voucher.contractNo != null && voucher.contractNo != ''">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.contractNo}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="(tradeId == null || tradeId == -1) && settleProofId != null && settleProofId != -1">
                <div class="form-label">
                    <label>结算单号</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.no}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="tradeId != null && tradeId != -1">
                <div class="form-label">
                    <label>累计订单金额</label>
                </div>
                <div class="form-value">
                    <span>{{(parseFloat(voucher.totalZxAmount || 0)).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center" v-if="(tradeId == null || tradeId == -1) && settleProofId != null && settleProofId != -1">
                <div class="form-label">
                    <label>结算金额</label>
                </div>
                <div class="form-value">
                    <span>{{(parseFloat(voucher.settleAmount || 0)).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center" v-if="tradeId != null && tradeId != -1">
                <div class="form-label">
                    <label>实付金额</label>
                </div>
                <div class="form-value">
                    <span>{{(parseFloat(voucher.paidAmount || 0)).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center" v-if="(tradeId == null || tradeId == -1) && settleProofId != null && settleProofId != -1">
                <div class="form-label">
                    <label>已支付金额</label>
                </div>
                <div class="form-value">
                    <span>{{parseFloat(voucher.paymentAmount || 0).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已退款金额</label>
                </div>
                <div class="form-value">
                    <span>{{(parseFloat(voucher.refundedAmount || 0)).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已申请退款金额</label>
                </div>
                <div class="form-value">
                    <span>{{(parseFloat(voucher.appliedRefundAmount || 0)).toFixed(2)}}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否支付完毕</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.payFinished">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-group center" v-if="tradeId != null && tradeId != -1 && voucher.paidAmount > 0 && voucher.paidAmount > applingRefundAmount && (voucher.payWay == 0 || voucher.payWay == 1 && voucher.contractNo != null && voucher.contractNo != '')">
                <div class="form-label">
                    <label>是否申请退款</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="showFlag" @change="radioChange();">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="(tradeId == null || tradeId == -1) && settleProofId != null && settleProofId != -1 && (parseFloat(voucher.paymentAmount || 0) - parseFloat(voucher.appliedRefundAmount || 0)) > 0">
                <hr class="dashed"/>
                <div class="form-label">
                    <label>是否申请退款</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="showFlag" @change="radioChange();">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <el-form :model="payVoucher" :rules="checkPay" ref="ruleForm">
            <div class="simple-form" v-if="showFlag">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">支付单据号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="payNo">
                            <el-input class="width-2x" v-model="payNo" :disabled="disabled" @blur="getPayVoucherByNo();"></el-input>
                            <span class="font-red">每笔支付仅支持一次退款</span>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">本次申请退款金额(元)</label>
                    </div>
                    <div class="form-value">
                        <div class="value">
                            <el-form-item prop="amount">
                                <div v-if="voucher.contractNo != null && voucher.contractNo != ''">
                                    <el-input class="width-2x" v-model="voucher.amount" @change="amountChange"></el-input>
                                </div>
                                <div class="width-2x" v-else>
                                    <span>{{voucher.amount}}</span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-group top">
                    <div class="form-label">
                        <label class="required">申请描述</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="applyDesc">
                            <textarea class="width-2x" placeholder="请输入" v-model="payVoucher.applyDesc"></textarea>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group top">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="memo">
                            <textarea class="width-2x" placeholder="请输入" v-model="payVoucher.memo"></textarea>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="form-toolbar" v-if="showFlag">
            <button class="swb-btn" @click="applyRefundOption();">申请退款</button>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="refundVoucherList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="no" label="退款单号" width="183px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="settleProofNo" label="结算单号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payNo" label="支付单号" width="183px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tradeNo" label="交易单号" width="183px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sellerName" label="客户名称" width="150px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subject" label="退款主题" width="150px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payWayText" label="退款方式" width="100px;"></el-table-column>
                <el-table-column prop="amount" label="退款金额(元)" width="130px;" align="right"></el-table-column>
                <!--<el-table-column prop="paidAmount" label="原支付金额(元)" width="140px;" align="right"></el-table-column>-->
                <el-table-column prop="auditStateText" label="审核状态" width="120px;"></el-table-column>
                <el-table-column prop="refundResultText" label="退款结果" width="100px;"></el-table-column>
                <el-table-column prop="createTime" label="创建日期" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import tradeApi from '../../api/trade'
    import finacApi from '../../api/finac'
    import settleApi from '../../api/settle'

    import SwbTradeVoucherList from './TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    export default{
        name: 'swb-trade-refund-info',
        path: '/pay/refund/info',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '交易单退款信息',
        data: function () {
            let self = this;
            let checkAmount = function (rule, value, callback) {
                if(Utils.isNoB(self.voucher.amount)) {
                    callback(new Error('本次退款金额不能为空'));
                } else {
                    if(!Utils.isMoneyStr(self.voucher.amount)) {
                        callback(new Error('必须是金额'));
                    } else {
                        if(self.voucher.amount <= 0) {
                            callback(new Error('本次申请退款金额必须大于零'));
                        } else {
                            let applyAbledAmount = self.payVoucher.amount - parseFloat(self.payVoucher.appliedRefundAmount || 0);
                            if(self.voucher.amount > applyAbledAmount) {
                                callback(new Error('该金额超过了可以申请退款的金额'));
                            } else {
                                callback();
                            }
                        }
                    }
                }
            };
            let checkApplyDesc = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请退款原因'));
                } else {
                    callback();
                }
            };
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                voucher: {},
                payVoucher: {},
                payItems: [], // 交易支付项
                tradeId: null,
                settleProofId: null,
                payNo: null,
                payVoucherList: [],
                refundVoucherList: [],
                applingRefundAmount: 0,
                showFlag: false,
                disabled: false,
                checkPay: {
                    amount: [{validator: checkAmount, trigger: 'blur'}],
                    applyDesc: [{validator: checkApplyDesc, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.tradeId = this.$route.query.tradeId || null;
            this.settleProofId = this.$route.query.settleProofId || null;
            this.payNo = this.$route.query.payNo || null;
            //
            this.getRefundVoucherList();
        },
        methods: {
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(SwbTradeVoucherList.path, action, targetPostId);
            },
            // 申请金额事件
            amountChange: function () {
                let voucher = this.voucher || {};
                if(!Utils.isNoB(voucher.amount)) {
                    voucher.amount = parseFloat(voucher.amount).toFixed(2);
                }
                this.voucher = Utils.merge({}, voucher);
            },
            //
            getVoucherDetail: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                tradeApi.getTradeVoucherInfo(postData, function (result) {
                    if(result.type == 'info') {
                        let voucher = result.data;
                        voucher.payAmount = voucher.totalZxAmount - voucher.appliedPayAmount;
                        self.voucher = Utils.merge({}, voucher);
                        //
                        if(!Utils.isNoB(self.payNo)) {
                            self.disabled = true;
                            self.getPayVoucherByNo();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 获取结算单信息
            getSettleProofDetail: function (id) {
                let self = this;
                settleApi.getSettleProof(id, function (result) {
                    if(result.type == 'info') {
                        let voucher = result.data || {};
                        voucher.payAmount = voucher.totalZxAmount - voucher.appliedPayAmount;
                        self.voucher = Utils.merge({}, voucher);
                        //
                        if(!Utils.isNoB(self.payNo)) {
                            self.disabled = true;
                            self.getPayVoucherByNo();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            getPayVoucherByNo: function () {
                let self = this;
                if(!Utils.isNoB(self.payNo)) {
                    let postData = {};
                    postData.no = self.payNo;
                    finacApi.getPayVoucherByNo(postData, function (result) {
                        if(result.type == 'info') {
                            self.payVoucher = result.data || {};
                            if(!Utils.isNoB(self.payVoucher) && self.payVoucher.id > 0) {
                                self.voucher.amount = self.payVoucher.amount - self.payVoucher.appliedRefundAmount;
                                if(!Utils.isNoB(self.voucher.amount)) {
                                    self.voucher.amount = self.voucher.amount.toFixed(2);
                                }
                                self.payVoucher.applyDesc = null;
                                self.payVoucher.memo = null;
                                //
                                self.voucher = Utils.merge({}, self.voucher);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getRefundVoucherList();
            },
            getRefundVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.tradeId) && self.tradeId != -1) {
                    filterItems.tradeId = self.tradeId;
                } else if(!Utils.isNoB(self.settleProofId) && self.settleProofId != -1) {
                    filterItems.settleProofId = self.settleProofId;
                }
                filterItems.directFlag = getEnumInfoWith('directFlag', 'name', 'Bckward').value;
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getPayVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let refundVoucherList = result.data.rows;
                        if(!Utils.isNoB(refundVoucherList) && refundVoucherList.length > 0) {
                            let applingRefundAmount = 0;
                            for(let i = 0; i < refundVoucherList.length; i++) {
                                let refundVoucher = refundVoucherList[i];
                                //
                                let payWayInfo = getEnumInfoWith('payWay', 'value', refundVoucher.payWay);
                                if(payWayInfo != null) {
                                    refundVoucher.payWayText = payWayInfo.text;
                                }
                                //
                                let auditStatefo = getEnumInfoWith('auditState', 'value', refundVoucher.auditState);
                                if(!Utils.isNoB(auditStatefo)) {
                                    refundVoucher.auditStateText = auditStatefo.text;
                                }
                                //
                                let resultStateInfo = getEnumInfoWith('resultState', 'value', refundVoucher.payResult);
                                if(resultStateInfo != null) {
                                    if(resultStateInfo.name == "Failure") {
                                        refundVoucher.refundResultText = "退款失败";
                                    } else if(resultStateInfo.name == "Success") {
                                        applingRefundAmount += refundVoucher.amount;
                                        refundVoucher.refundResultText = "退款成功";
                                    } else {
                                        if(!Utils.isNoB(auditStatefo) && auditStatefo.name == 'AuditFail') {
                                            refundVoucher.refundResultText = "拒绝退款";
                                        } else {
                                            refundVoucher.refundResultText = "待退款";
                                            applingRefundAmount += refundVoucher.amount;
                                        }
                                    }
                                }
                                //
                                refundVoucher.amount = refundVoucher.amount.toFixed(2);
//                                refundVoucher.paidAmount = refundVoucher.paidAmount.toFixed(2);
                            }
                            self.applingRefundAmount = applingRefundAmount.toFixed(2);
                        } else {
                            self.applingRefundAmount = 0.00;
                        }
                        self.refundVoucherList = Utils.merge([], refundVoucherList);
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    //
                    if(!Utils.isNoB(self.tradeId) && self.tradeId != -1) {
                        self.getVoucherDetail(self.tradeId);
                    } else {
                        if(Utils.isNoB(self.settleProofId) || self.settleProofId == -1) {
                            MsgBox.warning("参数错误！");
                            return;
                        } else {
                            self.getSettleProofDetail(self.settleProofId);
                        }
                    }
                })
            },
            // 金额校验
            checkCurrAmount: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(Utils.isMoneyStr(value) && parseFloat(value) >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的数字!'));
                    }
                }
            },
            // 本次退款金额变化事件
            currAmountChangeEvent: function (row) {
                let currAmount = row.currAmount;
                if(!Utils.isNoB(currAmount)) {
                    if(Utils.isMoneyStr(currAmount) && parseFloat(currAmount) > 0) {
                        if(parseFloat(currAmount) > parseFloat(row.amount)) {
                            row.currAmount = null;
                            MsgBox.warning("退款金额不能大于本次支付金额!");
                        } else {
                            row.currAmount = parseFloat(currAmount).toFixed(2);
                        }
                    } else {
                        row.currAmount = null;
                        MsgBox.warning("请输入正确的金额!")
                    }
                }
                // 计算申请退款金额
                let payItems = this.payItems || [];
                let refundAmount = 0;
                for(let i = 0; i < payItems.length; i++) {
                    let payItem = payItems[i];
                    refundAmount += (Utils.isNoB(payItem.currAmount) ? 0 : parseFloat(payItem.currAmount));
                }
                //
                let voucher = this.voucher;
                voucher.amount = refundAmount.toFixed(2);
                this.voucher = Utils.merge(voucher, {});
            },
            // radio变化事件
            radioChange: function () {
                if(this.showFlag && this.voucher.paidAmount <= 0) {
                    MsgBox.warning("您没有支付金额,不能进行该操作！");
                    this.showFlag = false;
                }
            },
            // 申请退款
            applyRefundOption: function () {
                let self = this;
                if(self.showFlag) {
                    if(Utils.isNoB(self.payNo)) {
                        MsgBox.warning("支付单据号不能为空");
                    } else {
                        let payVoucher = self.payVoucher || {};
                        if(payVoucher.refundId > 0) {
                            MsgBox.warning("每笔支付仅支持一次退款");
                            return;
                        }
                        self.$refs['ruleForm'].validate(function (valid) {
                            if(valid) {
                                let refundVoucher = {};
                                if(!Utils.isNoB(payVoucher) && payVoucher.id > 0) {
                                    refundVoucher.payVoucherId = payVoucher.id;
                                    refundVoucher.payNo = self.payNo;
                                }
                                refundVoucher.directFlag = getEnumInfoWith('directFlag', 'name', 'Bckward').value;
                                refundVoucher.tradeId = self.voucher.id;
                                refundVoucher.tradeNo = self.voucher.no;
                                refundVoucher.tradeType = self.voucher.type;
                                refundVoucher.reqerType = self.voucher.buyerType;
                                refundVoucher.reqerId = self.voucher.buyerId;
                                refundVoucher.payWay = getEnumInfoWith('payWay', 'name', 'Offline').value;
                                refundVoucher.amount = self.voucher.amount;
                                refundVoucher.applyDesc = self.payVoucher.applyDesc;
                                refundVoucher.memo = payVoucher.memo;
                                // 申请退款
                                let lastMsgBoxDlg = MsgBox.loading();
                                finacApi.savePayVoucherRefund(refundVoucher, function (result) {
                                    if(result.type === "info") {
                                        setTimeout(function () {
                                            lastMsgBoxDlg.close();
                                            MsgBox.success("申请退款成功");
                                            self.showFlag = false;
                                            self.payVoucher.applyDesc = null;
                                            self.payVoucher.memo = null;
                                            self.getRefundVoucherList();
                                        }, 3000);
                                    } else {
                                        lastMsgBoxDlg.close();
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                MsgBox.warning("校验失败");
                            }
                        });
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeRefundInfo.vue